<template>
  <div class="vcombo-wrap" ref="wrap">
    <CButton
      type="button"
      color="light"
      class="vcombo-trigger w-100 text-left"
      @click="toggle"
    >
      <span class="vcombo-trigger-inner">
        <template v-if="selectedOpt">
          <code class="text-dark">{{ selectedOpt.name }}</code>
          <CBadge v-if="selectedOpt.required" color="danger" class="ml-1">obrig</CBadge>
          <small v-if="selectedOpt.hint" class="text-muted ml-1">· {{ selectedOpt.hint }}</small>
        </template>
        <span v-else class="text-muted">Selecione o campo destino…</span>
      </span>
      <fa-icon :icon="open ? 'chevron-up' : 'chevron-down'" class="text-muted ml-auto" style="font-size:11px;flex-shrink:0" />
    </CButton>

    <div v-if="open" class="vcombo-pop">
      <div class="vcombo-search-wrap p-2 border-bottom">
        <div class="input-group input-group-sm">
          <div class="input-group-prepend">
            <span class="input-group-text"><fa-icon icon="search" /></span>
          </div>
          <input ref="qi" class="form-control form-control-sm" placeholder="Buscar campo Verso…" v-model="q" @keydown.esc="open = false" />
        </div>
      </div>
      <div class="vcombo-list">
        <div v-if="filteredOpts.length === 0" class="p-3 text-center text-muted small">Nenhum campo encontrado</div>
        <template v-for="(opts, cat) in groupedOpts">
          <div :key="cat + '__h'" class="vcombo-cat">{{ cat }}</div>
          <div
            v-for="opt in opts"
            :key="opt.name"
            class="vcombo-opt"
            :class="{ selected: opt.name === value }"
            @click="select(opt.name)"
          >
            <code class="vcombo-opt-name">{{ opt.name }}</code>
            <CBadge v-if="opt.required" color="danger" class="ml-1">obrig</CBadge>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "VersoCombobox",
  props: {
    value: { type: String, default: "" },
    options: { type: Array, default: () => [] },
  },
  data() { return { open: false, q: "" }; },
  computed: {
    normalizedOpts() {
      return this.options.map(o =>
        typeof o === "string" ? { name: o, category: "Outros", required: false, hint: "" } : o
      );
    },
    selectedOpt() { return this.normalizedOpts.find(o => o.name === this.value) || null; },
    filteredOpts() {
      if (!this.q) return this.normalizedOpts;
      const s = this.q.toLowerCase();
      return this.normalizedOpts.filter(o => o.name.toLowerCase().includes(s));
    },
    groupedOpts() {
      const g = {};
      this.filteredOpts.forEach(o => {
        const cat = o.category || "Outros";
        if (!g[cat]) g[cat] = [];
        g[cat].push(o);
      });
      return g;
    },
  },
  methods: {
    toggle() {
      this.open = !this.open;
      if (this.open) this.$nextTick(() => { if (this.$refs.qi) this.$refs.qi.focus(); });
    },
    select(name) { this.$emit("input", name); this.open = false; this.q = ""; },
    onDocClick(e) { if (this.$refs.wrap && !this.$refs.wrap.contains(e.target)) this.open = false; },
  },
  mounted() { document.addEventListener("mousedown", this.onDocClick); },
  beforeDestroy() { document.removeEventListener("mousedown", this.onDocClick); },
};
</script>

<style scoped>
.vcombo-wrap { position: relative; }
.vcombo-trigger { display: flex !important; align-items: center; gap: 6px; }
.vcombo-trigger-inner { flex: 1; display: flex; align-items: center; gap: 6px; overflow: hidden; min-width: 0; }
.vcombo-pop {
  position: absolute; top: calc(100% + 4px); left: 0; right: 0;
  background: #fff; border: 1px solid #dee2e6; border-radius: 6px;
  box-shadow: 0 8px 24px rgba(0,0,0,0.12); z-index: 9999;
  max-height: 300px; display: flex; flex-direction: column;
}
.vcombo-list { overflow-y: auto; flex: 1; }
.vcombo-cat {
  padding: 4px 12px; font-size: 10px; font-weight: 700; color: #6c757d;
  text-transform: uppercase; letter-spacing: 0.5px;
  background: #f8f9fa; border-bottom: 1px solid #dee2e6;
  position: sticky; top: 0;
}
.vcombo-opt { padding: 7px 12px; font-size: 12.5px; cursor: pointer; display: flex; align-items: center; gap: 6px; border-left: 3px solid transparent; }
.vcombo-opt:hover { background: #f8f9fa; }
.vcombo-opt.selected { border-left-color: #3a3e81; background: #eceaf3; }
.vcombo-opt-name { color: #343a40; font-size: 12px; flex: 1; }
</style>
